<template>
  <section>
    <div class="grid gap-4 xl:grid-cols-6 grid-cols-3">
      <div v-for="d in data" :key="d.id">
        <div class="border-1 border-borderColor rounded-md p-2">
          <Avatar
            :classStr="'h-20 w-20 m-auto'"
            :src="baseUrlSrc(d.thumbnail_url)"
            :title="d.f_name + ' ' + d.l_name"
          />
          <p class="text-gray-dark text-sm py-2 capitalize text-center font-medium">
            {{ d.f_name + " " + d.l_name }}
          </p>
        </div>
      </div>
    </div>
    <p class="text-gray-dark text-xs" v-if="data.length == 0">No data found.</p>
  </section>
</template>

<script>
import { Avatar } from "@/components/t-components";

export default {
  name: "FollowedTrainer",
  components: {
    Avatar,
  },
  props: {
    data: Array,
  },
  data() {
    return {};
  },
};
</script>